// In-house, privacy-first nudge analytics. Fire-and-forget: never blocks
// rendering or the signup flow, never throws, stores no visitor PII.

const URL = `${process.env.REACT_APP_BACKEND_URL}/api/nudge/events`;

export function trackNudge(event, variant, token) {
  try {
    const body = JSON.stringify({ event, variant, token: token || null });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(URL, new Blob([body], { type: "application/json" }));
    } else {
      fetch(URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch (e) {
    void e;
  }
}
